/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
import React from 'react';
import { Helmet } from 'react-helmet';
import { useStaticQuery } from 'gatsby';
var SEO = function SEO(_ref) {
    var _ref$description = _ref.description, description = _ref$description === void 0 ? '' : _ref$description, _ref$lang = _ref.lang, lang = _ref$lang === void 0 ? 'en' : _ref$lang, _ref$meta = _ref.meta, meta = _ref$meta === void 0 ? [] : _ref$meta, title = _ref.title, faviconHref = _ref.faviconHref;
    var _useStaticQuery = useStaticQuery("63159454"), site = _useStaticQuery.site;
    var metaDescription = description || site.siteMetadata.description;
    return /*#__PURE__*/ React.createElement(Helmet, {
        htmlAttributes: {
            lang: lang
        },
        title: title,
        titleTemplate: site.siteMetadata.title + " | %s",
        link: [{
                rel: 'icon',
                type: 'image/png',
                href: faviconHref
            }],
        meta: [{
                name: 'description',
                content: metaDescription
            }, {
                property: 'og:title',
                content: title
            }, {
                property: 'og:description',
                content: metaDescription
            }, {
                property: 'og:type',
                content: 'website'
            }, {
                name: 'twitter:card',
                content: 'summary'
            }, {
                name: 'twitter:creator',
                content: site.siteMetadata.author
            }, {
                name: 'twitter:title',
                content: title
            }, {
                name: 'twitter:description',
                content: metaDescription
            }].concat(meta)
    });
};
export default SEO;
